import { useMutation } from '@tanstack/vue-query';
import { type AxiosError, type AxiosResponse } from 'axios';

import { axios } from '@/helpers/axios';

export interface ProfileUpdateFormData {
  language: string
}

export function useProfileUpdateMutation() {
  return useMutation<
    AxiosResponse,
    AxiosError,
    ProfileUpdateFormData
  >({
    mutationFn: (data) => axios.patch('profile', data),
  });
}
